import map_usa from '../assets/img/icons/common/map_usa.png';
import map_canada from '../assets/img/icons/common/map_canada.png'

const regions = [
    { id: 1, name: "USA", img: map_usa },
    { id: 2, name: "Canada", img: map_canada }
]

export default regions